import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { initializeDefaultData } from './db/database';
import Login from './components/Login';
import StationSelect from './components/StationSelect';
import NodeSelect from './components/NodeSelect';
import Products from './components/Products';
import OrderConfirm from './components/OrderConfirm';
import OrdersList from './components/OrdersList';
import ConnectServer from './components/ConnectServer';
import OrdersReversed from './components/OrdersReversed'; // <-- NUEVO
import AccountScanner from './components/AccountScanner'; // Entregas por cuenta (QR)

const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white text-xl">Cargando...</div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/" />;
};

function AppContent() {
  useEffect(() => {
    initializeDefaultData();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/stations"
        element={
          <ProtectedRoute>
            <StationSelect />
          </ProtectedRoute>
        }
      />
      <Route
        path="/nodes"
        element={
          <ProtectedRoute>
            <NodeSelect />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <Products />
          </ProtectedRoute>
        }
      />
      <Route
        path="/confirm"
        element={
          <ProtectedRoute>
            <OrderConfirm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <OrdersList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/connect"
        element={
          <ProtectedRoute>
            <ConnectServer />
          </ProtectedRoute>
        }
      />
      {/* NUEVA RUTA ÓRDENES REVERSADAS */}
      <Route
        path="/orders-reversed"
        element={
          <ProtectedRoute>
            <OrdersReversed />
          </ProtectedRoute>
        }
      />
      {/* RUTA ENTREGAS POR CUENTA (QR) */}
      <Route
        path="/account-scanner"
        element={
          <ProtectedRoute>
            <AccountScanner />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="relative min-h-screen">
          <AppContent />
          <div className="fixed bottom-2 right-2 bg-gray-900/80 text-gray-300 text-xs px-2 py-1 rounded shadow-lg">
            V3.5
          </div>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;